import { applicationStatesValues } from '@/utils/checklistGroupMappings'

export const userGroups = {
  SALES: 'sales',
  PROCESSING: 'processing',
  UNDERWRITING: 'underwriting',
  VALUATIONS: 'valuations',
  UAM_REVIEW: 'uam-review',
  UW_REVIEW: 'uw-review',
  CLOSING: 'closing',
  POST_CLOSING: 'post-closing',
  PROPERTY_REVIEW: 'property-review',
  TS_ROUND_ROBIN: 'ts-round-robin',
  PC_ROUND_ROBIN: 'pc-round-robin',
  LOCK_OVERRIDE: 'lock_override',
  SERVICING: 'servicing',
  UNRESTRICTED_CRS: 'unrestricted-crs',
  DSCR_REVIEW: 'dscr-review',
  THIRD_LIEN_REVIEW: '3rd-lien-review',
  HEO_MANAGER: 'heo-manager',
  HOMEOWNER_SUPPORT_REP: 'homeowner-support-rep',
}

export const ENABLED_OFFER_STATES_GROUP = {
  [userGroups.SALES]: [
    applicationStatesValues.QUALIFICATION,
    applicationStatesValues.APP_SUBMIT,
    applicationStatesValues.DOC_UPLOAD,
    applicationStatesValues.FILE_SETUP,
    applicationStatesValues.CLOSED_LOST,
  ],
  [userGroups.HOMEOWNER_SUPPORT_REP]: [
    applicationStatesValues.QUALIFICATION,
    applicationStatesValues.APP_SUBMIT,
    applicationStatesValues.DOC_UPLOAD,
    applicationStatesValues.FILE_SETUP,
    applicationStatesValues.CLOSED_LOST,
  ],
  [userGroups.PROCESSING]: [
    applicationStatesValues.COND_APPROVAL,
    applicationStatesValues.IE_DELIVERY,
    applicationStatesValues.IE_INTENT_TO_PROCEED,
    applicationStatesValues.ORDER_OUT,
    applicationStatesValues.THIRD_RD_PARTY_RECEIPTS,
    applicationStatesValues.FINAL_APPROVAL_UW,
  ],
  [userGroups.VALUATIONS]: [applicationStatesValues.FINAL_APPROVAL_UW],
  [userGroups.UNDERWRITING]: [
    applicationStatesValues.FINAL_APPROVAL_UW,
    applicationStatesValues.FINAL_APPROVAL_UAM,
  ],
  [userGroups.UAM_REVIEW]: [
    applicationStatesValues.FINAL_APPROVAL_UW,
    applicationStatesValues.FINAL_APPROVAL_UAM,
  ],
  [userGroups.UW_REVIEW]: [
    applicationStatesValues.FINAL_APPROVAL_UW,
    applicationStatesValues.FINAL_APPROVAL_UAM,
  ],
  [userGroups.CLOSING]: [
    applicationStatesValues.ICS_SIGNATURE,
    applicationStatesValues.DOC_DRAW,
    applicationStatesValues.SIGNATURE,
    applicationStatesValues.ESCROW_DISBURSEMENT,
    applicationStatesValues.RECORDING,
  ],
  [userGroups.POST_CLOSING]: [
    applicationStatesValues.ICS_SIGNATURE,
    applicationStatesValues.DOC_DRAW,
    applicationStatesValues.SIGNATURE,
    applicationStatesValues.ESCROW_DISBURSEMENT,
    applicationStatesValues.RECORDING,
  ],
  [userGroups.HEO_MANAGER]: [
    applicationStatesValues.QUALIFICATION,
    applicationStatesValues.APP_SUBMIT,
    applicationStatesValues.DOC_UPLOAD,
    applicationStatesValues.FILE_SETUP,
    applicationStatesValues.FINAL_APPROVAL_UW,
    applicationStatesValues.IE_DELIVERY,
    applicationStatesValues.IE_INTENT_TO_PROCEED,
    applicationStatesValues.ORDER_OUT,
    applicationStatesValues.THIRD_RD_PARTY_RECEIPTS,
    applicationStatesValues.CLOSED_LOST,
  ],
  [userGroups.SERVICING]: [
    applicationStatesValues.QUALIFICATION,
    applicationStatesValues.APP_SUBMIT,
    applicationStatesValues.DOC_UPLOAD,
    applicationStatesValues.FILE_SETUP,
    applicationStatesValues.FINAL_APPROVAL_UW,
    applicationStatesValues.CLOSED_WON,
  ],
  // TODO: Pending to add TS manager
}
